import type { OptionsProps } from '@/components/atoms/select/Select';

const propertyRegimeOptions: OptionsProps[] = [
  { value: 'partial_communion_of_goods', label: 'Comunhão Parcial de Bens' },
  {
    value: 'universal_communion_of_goods',
    label: 'Comunhão Universal de Bens',
  },
  { value: 'stable_union', label: 'União Estável' },
  {
    value: 'partnership_of_acquests',
    label: 'Participação Final nos Aquestos',
  },
  {
    value: 'absolute_separation_of_goods',
    label: 'Separação Absoluta de Bens',
  },
  { value: 'legal_separation_of_goods', label: 'Separação Legal de Bens' },
];

export default propertyRegimeOptions;
